const AKAMAI_TIERS = [320, 640, 1024];

const isAkamai = (url) => !!url && url.includes('thdstatic.com') && !url.split('?')[0].endsWith('.gif');

const buildImwidthSrc = (url, width) => `${url}${url.includes('?') ? '&' : '?'}imwidth=${width}`;

export const akamaiSrc = (url, width) => (isAkamai(url) ? buildImwidthSrc(url, width) : url);

export const akamaiSrcSet = (url) => (
  isAkamai(url)
    ? AKAMAI_TIERS.map((width) => `${buildImwidthSrc(url, width)} ${width}w`).join(', ')
    : undefined
);

const DESKTOP_TIERS = [1024, 2048];
const ORIGINAL_SRCSET_WIDTH = 3840; // > 2048 so any >2K need falls through to the raw original
export const akamaiSrcSetDesktop = (url) => {
  if (!isAkamai(url)) return undefined;
  const tiers = DESKTOP_TIERS.map((width) => `${buildImwidthSrc(url, width)} ${width}w`);
  return [...tiers, `${url} ${ORIGINAL_SRCSET_WIDTH}w`].join(', ');
};

/**
 * @deprecated Legacy fixed width+height resize (`Resize=(920,575)`). Retained for
 * backward compatibility only — prefer `akamaiSrc` / `akamaiSrcSet` (width-only
 * `imwidth`, which preserves aspect ratio). Do not use in new code .
 */
export const akamaiImageResize = (imageUrlToTransform) => {
  const queryParams = 'Resize=(920,575)';

  if (!imageUrlToTransform) {
    return imageUrlToTransform;
  }

  if (imageUrlToTransform.split('?')[0].endsWith('gif')) {
    return imageUrlToTransform.split('?')[0];
  }

  const isAkamaiHost = imageUrlToTransform.includes('thdstatic.com');
  if (!isAkamaiHost) {
    return imageUrlToTransform;
  }
  if (!imageUrlToTransform.includes('?')) {
    return `${imageUrlToTransform}?im=${queryParams}`;
  }
  if (imageUrlToTransform.includes('im=')) {
    const urlBeforeImParams = imageUrlToTransform.substring(
      0,
      imageUrlToTransform.indexOf('im=')
    );
    const imAndRemainderParams = imageUrlToTransform.substring(
      imageUrlToTransform.indexOf('im=')
    );
    const hasAdditionalParams = imAndRemainderParams.includes('&');
    if (hasAdditionalParams) {
      const remainderOfParams = imAndRemainderParams.substring(imAndRemainderParams.indexOf('&'));
      const imParams = imAndRemainderParams.substring(0, imAndRemainderParams.indexOf('&'));
      return `${urlBeforeImParams}${imParams};${queryParams}${remainderOfParams}`;
    }
    const imParams = imageUrlToTransform.substring(imageUrlToTransform.indexOf('im='));
    return `${urlBeforeImParams}${imParams};${queryParams}`;
  }
  return `${imageUrlToTransform}&im=${queryParams}`;
};
